import * as _ from 'underscore';
import { ID } from '../../const';
import { Templates } from '../../compile';
import { View } from 'mappMvc/models/views';
import { ViewOptions } from 'mappMvc/interfaces/options';

export class MissingTenant extends View {
	constructor(options: ViewOptions) {
		super(
			_.defaults(options, <ViewOptions>{
				viewId: ID.MissingTenant,
				template: Templates.base_missingTenant
			})
		);

		this.parent = null;
	}
}
